<template>
  <div class="ma-4">
    <ClientNav v-if="$route.query.clientNav !== 'false'"/>
    <v-row dense>
      <v-col cols="12">
        <v-spacer></v-spacer>
        <v-card>
          <v-card-title style="background-color: #2b3990">
            <span class="headline white--text">{{ titleForm }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form
                ref="form"
                lazy-validation>
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-datetime-picker
                      v-model="newDateTime"
                      label="Incident Date and Time"
                      prepend-icon="event"
                      :rules="requiredRules"
                    ></v-datetime-picker>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-autocomplete
                      v-model="newProgram"
                      label="Program"
                      :items="programs"
                      item-value="program"
                      item-text="program"
                      :rules="requiredRules"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-autocomplete
                      v-model="newShift"
                      label="Shift"
                      :items="shifts"
                      item-value="Shift"
                      item-text="Shift"
                      :rules="requiredRules"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-autocomplete
                      v-model="newBehaviors"
                      label="Behaviors Exhibited"
                      :rules="requiredRules"
                      :items="behaviorList"
                      item-value="Behaviors.Behavior"
                      item-text="Behavior"
                      multiple
                      @change="noBehaviors()"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      label="Other Behavior Not Listed Above"
                      v-model="newOtherBehaviors"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="12">
                    <v-select
                      v-model="newIntensity"
                      label="Intensity Key"
                      :rules="requiredRules"
                      :items="intensityKeys"
                      item-value="Intensity"
                      item-text="Intensity"

                    ></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="12">
                    <v-select
                      v-model="newMotivator"
                      label="Motivator Key"
                      :rules="requiredRules"
                      :items="motivatorKeys"
                      item-value="Motivator"
                      item-text="Motivator"

                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-textarea
                      label="Other Motives Not Listed Above"
                      v-model="newOtherMotives"
                      outlined
                    >
                    </v-textarea>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-textarea
                      label="Antecedent"
                      hint="What were the triggers that lead to the behavior? For example: Was weather a factor, or another client, or refusals to comply to staff requests, or an event in the community. Be DETAILED!"
                      v-model="newAnticedent"
                      :rules="requiredRules"
                      outlined

                    >
                    </v-textarea>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-textarea
                      label="Behavior"
                      hint="What was the actual event of the behavior. Describe in detail what the behavior looked like. If there was damage or injury to anyone, be specific. BE DETAILED!"
                      v-model="newBehaviorEvent"
                      :rules="requiredRules"
                      outlined
                    >
                    </v-textarea>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-textarea
                      label="Consequence"
                      hint="What were the results of the behavior? Describe in detail if there was law enforcement, hospitalization, further restrictions etc. BE DETAILED! IF THERE IS PROPERTY DAMAGE, INJURY, LAW ENFORCEMENT INVOLVED, YOU MUST COMPLETE AN INCIDENT REPORT!"
                      v-model="newConsequences"
                      :rules="requiredRules"
                      outlined
                    >
                    </v-textarea>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-textarea
                      label="Staff Assessment"
                      hint="How could staff have avoided this situation. IF NO BEHAVIOR WAS OBSERVED TYPE: N/A"
                      v-model="newStaffAssessment"
                      :rules="requiredRules"
                      outlined
                    >
                    </v-textarea>
                  </v-col>
                  <div class="font-weight-bold">Notification</div>
                  <div>Acknowledge that you notified your supervisor of all
                    behaviors encountered during your shift. Publish a message
                    on the charting site under the clients profile. Select NEW
                    MESSAGE and type a brief description of the behavior. IF NO
                    BEHAVIOR WAS OBSERVED SELECT: N/A
                  </div>
                  <v-col cols="12" sm="12">
                    <v-row>
                      <v-checkbox label="Yes" value="Yes"
                                  v-model="newNotification"
                                  class="mr-6"></v-checkbox>
                      <v-checkbox label="No" value="No"
                                  v-model="newNotification"
                                  class="mr-6"></v-checkbox>
                      <v-checkbox label="N/A" value="N/A"
                                  v-model="newNotification"
                                  class="mr-6"></v-checkbox>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-checkbox label="Signature" @click="addSignature()"
                                v-model="checkSignature" :rules="requiredRules">Signature
                    </v-checkbox>
                    <v-text-field v-if="signed === true" v-model="newCompletedBy"
                                  readonly :rules="requiredRules"></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="white--text" color="#259647" @click="addBehaviorReport()"
                   v-if="createBehaviorReport">Save
            </v-btn
            >
            <v-btn
              fab
              small
              @click="showPrintModal(behaviorId)"
              class="mr-8 mb-2 white--text"
              color="#2b6993"
              elevation="4"
              v-if="!createBehaviorReport && isAuditorRole"
            >
              <v-icon>print</v-icon>
            </v-btn>
            <v-btn color="blue darken-1" text @click="updateBehaviorReport()"
                   v-if="!createBehaviorReport && !isAuditorRole">Update
            </v-btn
            >
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Foot/>
  </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../../components/ClientNav'
import Foot from '../../../components/Footer'
import reports from "@/mixins/reports";
import {displaySuccess, displayError} from "@/service/notification-message.service";

import moment from 'moment'
import {mapActions} from "vuex";
import momentTz from "moment-timezone";
import {BEHAVIORS} from "src/constants/Behaviors";
import PrintUtil from "../../../../utils/print-util";
import DateTimeUtil from "../../../../utils/date-time.util";

const url = require("../../../client_config/config").url;

export default {
  components: {
    ClientNav,
    Foot,
  },
  mixins: [reports],
  data: function () {
    return {
      msg: false,
      search: "",
      text: "",
      behaviorReports: [],
      behavior: {},
      behaviors: BEHAVIORS,
      programs: ["Day Program", "Host Home", "Respite", "Residential", "Supported Living"],
      shifts: ["Day Program", "During School", "Morning - DSI", "Swing", "Grave", "Home Visit"],
      intensityKeys: ["No Behavior Observed", "1 - Mild", "2 - Moderate", "3 - Severe", "4 - Extreme"],
      motivatorKeys: ["No Behavior Observed", "1 - Anger", "2 - Anxiety", "3 - Get or obtain and object", "4 - Attention Seeking", "5 - Control/Independance",
        "6 - Sensory", "7 - Escape or to avoid", "8 - Other"],
      clientID: this.$route.params.clientID,
      behaviorId: this.$route.params.id,
      token: localStorage.getItem('token'),
      userID: localStorage.getItem("userID"),
      tempData: [],
      behaviorTempData: [],
      behaviorList: [],
      titleForm: "New Behavior Report",
      behaviorID: "",
      newDateTime: new Date(),
      newProgram: "",
      newShift: "",
      newBehaviors: [],
      users: [],
      newOtherBehaviors: "",
      newIntensity: "",
      newMotivator: "",
      newOtherMotives: "",
      newAnticedent: "",
      newBehaviorEvent: "",
      newConsequences: "",
      newStaffAssessment: "",
      newNotification: "",
      newCompletedBy: "",
      signed: false,
      checkSignature: false,
      staff: localStorage.getItem("Name"),
      editedIndex: -1,
      editedItem: {
        dateTime: "",
        program: "",
        shift: "",
        behaviors: [],
        otherBehaviors: "",
        intensity: "",
        motivator: "",
        otherMotives: "",
        anticedent: "",
        behaviorEvent: "",
        consequences: "",
        staffAssessment: "",
        notification: "",
        completedBy: "",
      },
      defaultItem: {
        dateTime: "",
        program: "",
        shift: "",
        behaviors: [],
        otherBehaviors: "",
        intensity: "",
        motivator: "",
        otherMotives: "",
        anticedent: "",
        behaviorEvent: "",
        consequences: "",
        staffAssessment: "",
        notification: "",
        completedBy: "",
      },
      isLoading: true,
      requiredRules: [
        v => !!v || 'This is required',
      ],
      addNewBehavior: "",
      menuStartDate: false,
      menuEndDate: false,
      newStartDate: null,
      newEndDate: null,
      textFieldProps: {
        appendIcon: "event"
      },
      startDateProps: {
        min: moment(new Date()).format("YYYY-MM-DD")
      },
      startTimeProps: {
        ampmInTitle: true
      },
      itemsPerPage: 10,
      totalServerItems: 0,
      paginationInfo: {},
      timezone: momentTz.tz.guess(),
      createBehaviorReport: false,
    };
  },

  computed: {
    client() {
      return {
        name: this.$store.state.clients?.client?.Name,
      };
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  watch: {},

  created() {
    this.createBehaviorReport = this.$route.query.createBehaviorReport === "true";
    this.getBehaviors();
    if (localStorage.getItem('userRole') === "Client") {
      this.client = true;
    }
  },

  mounted() {
    if (!this.createBehaviorReport) {
      this.getBehaviorReport();
    }

    window.addEventListener('keydown', async (event) => {
      const downloadUrl = await this.generateDownloadUrl();
      PrintUtil.handleKeydown(event, downloadUrl, this.id, this.token, 'BehaviorReport');
    });
  },

  beforeDestroy() {
    window.removeEventListener('keydown', (event) => {
      PrintUtil.handleKeydown(event, this.downloadUrl, this.id, this.token, 'BehaviorReport');
    });
  },

  methods: {
    ...mapActions({
      getClientInfo: "clients/getClient",
    }),
    initialize() {
      this.behaviorReports = [];
    },

    validate() {
      return this.$refs.form.validate()
    },

    viewBehaviorReport(item) {
      this.titleForm = "Viewing Behavior Report";
      this.newDateTime = moment(item.DateTime).local().format("YYYY-MM-DD hh:mm");
      this.newProgram = item.Program;
      this.newShift = item.Shift;
      this.newBehaviors = item.Behaviors;
      this.newOtherBehaviors = item.OtherBehaviors;
      this.newIntensity = item.Intensity;
      this.newMotivator = item.Motivator;
      this.newOtherMotives = item.OtherMotives;
      this.newAnticedent = item.Anticedent;
      this.newBehaviorEvent = item.BehaviorEvent;
      this.newConsequences = item.Consequences;
      this.newStaffAssessment = item.StaffAssessment;
      this.newNotification = item.Notification;
      if (item.CompletedBy !== "") {
        this.newCompletedBy = item.CompletedBy;
        this.signed = true;
        this.checkSignature = true;
       if(this.newCompletedBy.includes("Z")){
         this.newCompletedBy = this.formatSignature(this.newCompletedBy);
       }
      }
    },

    close() {
      this.$router.go(-1);
      this.resetForm();
    },

    async updateBehaviorReport() {
      const req_body = {
        DateTime: this.newDateTime,
        Program: this.newProgram,
        Shift: this.newShift,
        Behaviors: this.newBehaviors,
        OtherBehaviors: this.newOtherBehaviors,
        Intensity: this.newIntensity,
        Motivator: this.newMotivator,
        OtherMotives: this.newOtherMotives,
        Anticedent: this.newAnticedent,
        BehaviorEvent: this.newBehaviorEvent,
        Consequences: this.newConsequences,
        StaffAssessment: this.newStaffAssessment,
        Notification: this.newNotification,
        CompletedBy: this.newCompletedBy,
      };

      try {
        const response = await axios.put(`${url}/behaviorReports/${this.behaviorId}`, req_body)

        if (response.status !== 200) {
          displayError("Failed to update behavior report. Please try again.")
          return;
        }

        displaySuccess("The behavior report has been updated successfully.");
        this.getBehaviorReports();
      } catch (error) {
        displayError("Failed to update behavior report.")
      } finally {
        this.close();
      }
    },

    getBehaviorReports(item = {page: 1, itemsPerPage: 10}) {
      this.paginationInfo = item
      const {sortBy = [], sortDesc = []} = item;
      let sortField = 'DateTime', sortDirection = -1;
      if (sortBy.length > 0) sortField = sortBy[0] === 'newDateTime' ? 'DateTime' : sortBy[0];
      if (sortDesc.length > 0) {
        sortDirection = 1;
        if (sortDesc[0] === undefined || sortDesc[0] === true) sortDirection = -1;
      }

      this.isLoading = true;
      axios.get(`${url}/behaviorReports/${this.clientID}?page=${item.page}&limit=${item.itemsPerPage}&search=${this.search}&sortField=${sortField}&sortDirection=${sortDirection}&tz=${this.timezone}`).then(res => {
        this.behaviorReports = [];

        this.tempData.forEach(item => {
          this.behaviorReports.push({
            id: item._id,
            newDateTime: DateTimeUtil.toLocalDateTime(item.DateTime),
            program: item.Program,
            shift: item.Shift,
            behaviors: item.Behaviors,
            otherBehaviors: item.OtherBehaviors,
            completedBy: this.formatSignature(item.CompletedBy)
          })
        })

        this.totalServerItems = res.data.behaviors.totalDocs;

      }).finally(() => this.isLoading = false);
    },

    getBehaviors() {
      axios.get(`${url}/behaviors/client/${this.clientID}`).then(async (response) => {
        this.behaviorList = response.data.behaviors;
      });
    },

    getBehaviorReport() {
      axios.get(`${url}/behaviorReports/specific/${this.behaviorId}`).then(async (response) => {
        this.behavior = response.data.behavior;
        this.viewBehaviorReport(this.behavior);
      });
    },

    async addBehaviorReport() {
      if (this.validate()) {
        const req_body = {
          DateTime: this.newDateTime,
          Program: this.newProgram,
          Shift: this.newShift,
          Behaviors: this.newBehaviors,
          OtherBehaviors: this.newOtherBehaviors,
          Intensity: this.newIntensity,
          Motivator: this.newMotivator,
          OtherMotives: this.newOtherMotives,
          Anticedent: this.newAnticedent,
          BehaviorEvent: this.newBehaviorEvent,
          Consequences: this.newConsequences,
          StaffAssessment: this.newStaffAssessment,
          Notification: this.newNotification,
          CompletedBy: this.newCompletedBy,
          ClientID: this.clientID,
        };

        try {
          const response = await axios.post(`${url}/behaviorReports`, req_body)

          if (response.status !== 200) {
            displayError("Failed to add behavior report. Please try again.")
            return;
          }
          displaySuccess("The new behavior report has been added successfully.")
          this.getBehaviorReports();
        } catch (error) {
          displayError("Failed to add behavior report.")
        } finally {
          this.close();
        }
      } else {
        displayError("Please fill out all required fields.");
      }
    },

    addSignature() {
      if (this.signed === false) {
        this.newCompletedBy = this.staff + " - " + moment().utc().toISOString();
        this.signed = true;
      } else {
        this.newCompletedBy = "";
        this.signed = false;
      }
    },

    formatSignature(completedBy) {
      if (!completedBy || completedBy === "") {
        return "";
      }

      if (completedBy.includes("Z")) {
        const [name, utcTime] = completedBy.split(" - ");
        const cleanUtcTime = utcTime.replace("Z", ""); // Remove "Z" for parsing
        const localTime = moment.utc(cleanUtcTime, "YYYY-MM-DD HH:mm").local().format("YYYY-MM-DD HH:mm");
        return `${name} - ${localTime}`;
      }

      return completedBy;
    },

    noBehaviors() {
      if (this.newBehaviors.includes("No Behavior Observed")) {
        this.newIntensity = "No Behavior Observed";
        this.newMotivator = "No Behavior Observed";
        this.newAnticedent = "No Behavior Observed";
        this.newBehaviorEvent = "No Behavior Observed";
        this.newConsequences = "No Behavior Observed";
        this.newStaffAssessment = "No Behavior Observed"
      } else {
        this.newIntensity = "";
        this.newMotivator = "";
        this.newAnticedent = "";
        this.newBehaviorEvent = "";
        this.newConsequences = "";
        this.newStaffAssessment = ""
      }
    },

    async generateDownloadUrl() {
      return `${url}/behaviorReports/download?id=${this.behaviorId}`;
    },

    async showPrintModal() {
      const downloadUrl = await this.generateDownloadUrl();
      PrintUtil.showPrintOption(downloadUrl, this.behaviorId, this.token, 'BehaviorReport');
    },


    printTable() {

      let {page, itemsPerPage} = this.paginationInfo

      let headerFields = this.headers
        .filter((header) => header.value != "actions")
        .map((header) => header.value)
        .join(", ");

      let data = {
        query: {
          headers: headerFields,
          search: this.search,
          page: page,
          limit: itemsPerPage,
          name: this.client.name,
        },
        id: this.clientID,
        route: 'behaviorReports'
      }

      this.getReport(data)

    },

    resetForm() {
      this.newDateTime = moment().toDate();
      this.newProgram = "";
      this.newShift = "";
      this.newBehaviors = [];
      this.newOtherBehaviors = "";
      this.newIntensity = "";
      this.newMotivator = "";
      this.newOtherMotives = "";
      this.newAnticedent = "";
      this.newBehaviorEvent = "";
      this.newConsequences = "";
      this.newStaffAssessment = "";
      this.newNotification = "";
      this.newCompletedBy = "";
      this.signed = false;
    },
  },

};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}


@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}

</style>
